// extracted by mini-css-extract-plugin
module.exports = {"f-AtomCard":"Card_f-AtomCard__wO8Sy","f-AtomCard-media":"Card_f-AtomCard-media__RByh6","f-AtomCard-content":"Card_f-AtomCard-content__kaQgo"};